<template>
  <scenario-modelling-component />
</template>

<script>
import ScenarioModellingComponent from "@/components/scenario-modelling/scenario-modelling";

export default {
  components: {
    ScenarioModellingComponent
  }
};
</script>

<style></style>
